import {computeFixedHeaderOffset} from "./computeFixedHeaderOffset";


// Why double requestAnimationFrame?
// - The first requestAnimationFrame schedules work after the current rendering cycle
// - The second requestAnimationFrame ensures all layout and paint operations are complete
// - This guarantees that element positions are accurate and stable before we calculate scroll positions

export function scrollToElement(el: Element, options?: { topOffset?: number }) {
  if (el) {
    // Wait for next animation frame to ensure layout is complete
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        var eventClientRect = el.getBoundingClientRect();
        var headerOffset = options?.topOffset || computeFixedHeaderOffset() || 0;
        var top = window.scrollY + eventClientRect.top - headerOffset;

        // If element is at top due to initial render, scroll to bring it into better view
        if (eventClientRect.top < 10 && eventClientRect.top > -10) {
          // Calculate the element's absolute position in the document
          const absoluteTop = window.scrollY + eventClientRect.top;
          // Scroll to position with header offset
          top = Math.max(0, absoluteTop - headerOffset - 100) // 100px buffer from top
        }

        // Only scroll if we're not already there (within 5px tolerance)
        if (Math.abs(eventClientRect.top - headerOffset) > 5) {
          if (window && typeof window.tickarooLiveblogScrollTo === 'function') {
            window.tickarooLiveblogScrollTo(top)
          } else {
            window.scrollTo({
              behavior: "smooth",
              top: top
            });
          }
        }
      })
    })
  }
}
